import { computed, ErrorHandler, signal, WritableSignal } from '@angular/core';
import { login } from './api/auth';

export class HttpError extends Error {
  constructor(public status: number, message: string) {
    super(message);
  }
}

export const errorMessage: WritableSignal<string | null> = signal(null);
export const hasError = computed(() => errorMessage() !== null);

export function handleError(error: unknown) {
  if (error instanceof HttpError) {
    if (error.status === 401) {
      console.log('Got 401 Unauthorized, trying to login again');
      login();
      // FIXME can we break the loop, if a request always returns 401
      return;
    }
    if (error.status === 403) {
      console.error(error);
      errorMessage.set($localize`:@@http-403-forbidden:Access Denied, missing permissions.`);
      return;
    }
  }

  console.error(error);
  errorMessage.set($localize`:@@unexpected-error:An unexpected error occured.`);
}

export function clearError() {
  errorMessage.set(null);
}

export function setDuplicateUsernameError() {
  errorMessage.set(
    $localize`:@@error-username-already-exists:A user with this username already exists.`,
  );
  window.scroll({ top: 0, left: 0, behavior: 'smooth' });
}

export class AppErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    handleError(error);
  }
}
